export function adaptInvoiceListFromAPI(items: IInvoiceDTO[]): IInvoiceList {
  return items.map(item => adaptInvoiceFromAPI(item));
}

export function adaptInvoiceFromAPI(data: IInvoiceDTO): IInvoice {
  return data
    ? createInvoice({
      ...data,
      documentURL: !data.documentURL ? '' : data.documentURL,
      xmlURL: !data.xmlURL ? '' : data.xmlURL,
      billingDate: convertToBrDate(data.billingDate),
      finalCustomerDocument: CompanyDocument(data.finalCustomerDocument).masked,
    })
    : createInvoice();
}
